var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.74902H4.5C3.25736 3.74902 2.25 4.75638 2.25 5.99902V19.499C2.25 20.7417 3.25736 21.749 4.5 21.749H19.5C20.7426 21.749 21.75 20.7417 21.75 19.499V5.99902C21.75 4.75638 20.7426 3.74902 19.5 3.74902Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6478 3.74902H5.35219C3.64172 3.74902 2.25 5.1623 2.25 6.89902V9.74902H3C3 8.99902 3.75 8.24902 4.5 8.24902H19.5C20.25 8.24902 21 8.99902 21 9.74902H21.75V6.89902C21.75 5.1623 20.3583 3.74902 18.6478 3.74902Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 11.999C14.4962 11.999 14.9999 11.4953 14.9999 10.874C14.9999 10.2527 14.4962 9.74902 13.8749 9.74902C13.2536 9.74902 12.7499 10.2527 12.7499 10.874C12.7499 11.4953 13.2536 11.999 13.8749 11.999Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6249 11.999C18.2462 11.999 18.7499 11.4953 18.7499 10.874C18.7499 10.2527 18.2462 9.74902 17.6249 9.74902C17.0036 9.74902 16.4999 10.2527 16.4999 10.874C16.4999 11.4953 17.0036 11.999 17.6249 11.999Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 15.7485C14.4962 15.7485 14.9999 15.2449 14.9999 14.6235C14.9999 14.0022 14.4962 13.4985 13.8749 13.4985C13.2536 13.4985 12.7499 14.0022 12.7499 14.6235C12.7499 15.2449 13.2536 15.7485 13.8749 15.7485Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6249 15.7485C18.2462 15.7485 18.7499 15.2449 18.7499 14.6235C18.7499 14.0022 18.2462 13.4985 17.6249 13.4985C17.0036 13.4985 16.4999 14.0022 16.4999 14.6235C16.4999 15.2449 17.0036 15.7485 17.6249 15.7485Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 15.7485C6.99632 15.7485 7.5 15.2449 7.5 14.6235C7.5 14.0022 6.99632 13.4985 6.375 13.4985C5.75368 13.4985 5.25 14.0022 5.25 14.6235C5.25 15.2449 5.75368 15.7485 6.375 15.7485Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1249 15.7485C10.7462 15.7485 11.2499 15.2449 11.2499 14.6235C11.2499 14.0022 10.7462 13.4985 10.1249 13.4985C9.50356 13.4985 8.99988 14.0022 8.99988 14.6235C8.99988 15.2449 9.50356 15.7485 10.1249 15.7485Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 19.499C6.99632 19.499 7.5 18.9953 7.5 18.374C7.5 17.7527 6.99632 17.249 6.375 17.249C5.75368 17.249 5.25 17.7527 5.25 18.374C5.25 18.9953 5.75368 19.499 6.375 19.499Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1249 19.499C10.7462 19.499 11.2499 18.9953 11.2499 18.374C11.2499 17.7527 10.7462 17.249 10.1249 17.249C9.50356 17.249 8.99988 17.7527 8.99988 18.374C8.99988 18.9953 9.50356 19.499 10.1249 19.499Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 19.499C14.4962 19.499 14.9999 18.9953 14.9999 18.374C14.9999 17.7527 14.4962 17.249 13.8749 17.249C13.2536 17.249 12.7499 17.7527 12.7499 18.374C12.7499 18.9953 13.2536 19.499 13.8749 19.499Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99988 2.24902V3.74902",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 2.24902V3.74902",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1d2e93459c785de111bd03e1c0385f78.svg";
export { ForwardRef as ReactComponent };